import React, { useState, useEffect } from 'react';
import { IoCall } from "react-icons/io5";
import { FaHistory, FaWpforms } from "react-icons/fa";
import { useFloatingPanel } from './useFloatingPanelState';

const DashboardButtons = () => {
  const { togglePhone, toggleHistory, toggleForm } = useFloatingPanel();
  const [showIcon, setShowIcon] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const showCallIcon = sessionStorage.getItem("showCallIcon");
      if (showCallIcon === null) {
        setShowIcon(true);
      } else if (showCallIcon === "false") {
        setShowIcon(false);
      } else {
        setShowIcon(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (showIcon === false) {
    return null;
  }

  const buttonStyle = (color) => ({
    border: "none",
    borderRadius: "12px",
    width: "48px",
    height: "48px",
    color: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color,
    transition: "transform 0.3s",
    cursor: "pointer"
  });

  return (
    <div className="d-flex flex-column gap-3 open-btn" style={{ padding: "8px" }}>
      <button onClick={togglePhone} style={buttonStyle('rgb(8, 29, 93)')}>
        <IoCall style={{ fontSize: "24px" }} />
      </button>
      {/* <button onClick={toggleHistory} style={buttonStyle('#28a745')}>
        <FaHistory style={{ fontSize: "24px" }} />
      </button>
      <button onClick={toggleForm} style={buttonStyle('#000099')}>
        <FaWpforms style={{ fontSize: "24px" }} />
      </button> */}
    </div>
  );
};

export default DashboardButtons;
